LS.util.route({
	'account': {
		'$guard:eval': {
			'teams': {
				'$index': {
					':load': 'account.teams',
					':unload': 'account.teams:unload'
				},
				'$num': {
					'$root': {
						':load': 'account.team',
						':unload': 'account.team:unload'
					},
					'users': {
						'$index': {
							':load': 'account.team-users',
							':unload': 'account.team-users:unload'
						}
					}
				},
				'create': {
					':load': 'account.team',
					':unload': 'account.team:unload'
				}
			}
		}
	}
});